import { render, staticRenderFns } from "./knowledgetzbs.vue?vue&type=template&id=729887b7&scoped=true&"
import script from "./knowledgetzbs.vue?vue&type=script&lang=js&"
export * from "./knowledgetzbs.vue?vue&type=script&lang=js&"
import style0 from "./knowledgetzbs.vue?vue&type=style&index=0&id=729887b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729887b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('729887b7')) {
      api.createRecord('729887b7', component.options)
    } else {
      api.reload('729887b7', component.options)
    }
    module.hot.accept("./knowledgetzbs.vue?vue&type=template&id=729887b7&scoped=true&", function () {
      api.rerender('729887b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/physical/knowledgetzbs.vue"
export default component.exports